import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useTrackView } from '#src/app/shared/hooks/tracking';

import { useBannerDismissalStorage } from '../../../PageBanner/hooks/useBannerDismissalStorage';
import { ENDORSEMENTS_BANNER_KEY } from '../../constants';

type UseEndorsementsBannerReturn = ModelHookResult<
	{ isDismissed: boolean },
	{ handleDismiss: () => void; handleCtaClick: () => void }
>;

export function useEndorsementsBanner(): UseEndorsementsBannerReturn {
	const track = useTracking();
	const { isBannerDismissed, setBannerDismissed } = useBannerDismissalStorage();

	const isDismissed = isBannerDismissed(ENDORSEMENTS_BANNER_KEY);

	useTrackView('petition_manage_notification_view', { notification: 'ADD_ENDORSEMENT' });

	const handleDismiss = useCallback(() => {
		setBannerDismissed(ENDORSEMENTS_BANNER_KEY);
	}, [setBannerDismissed]);

	const handleCtaClick = useCallback(() => {
		void track('petition_manage_notification_cta_click', {
			notification: 'ADD_ENDORSEMENT',
		});
	}, [track]);

	return {
		data: { isDismissed },
		actions: { handleDismiss, handleCtaClick },
	};
}
